import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';
import { PAGE_SIZE_IMAGE } from '../app/constant/config';

const STORAGE_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/ivis/storage/api/v0'
  : 'https://storage.vgps.vn/ivis/storage/api/v0';


export const GetImages = createAsyncThunk(
  'imageSlice/GetImage',
  ({ payload }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      const { serial, page, page_size, camera, start_date, end_date } = payload;
      const serialParam = serial ? `serial=${serial}&` : '';
      axios({
        baseURL: '',
        url: `${STORAGE_BASE_URL}/device/captures?${serialParam}camera=${camera || ''}&start_date=${start_date || ''}&end_date=${end_date || ''}&page=${page || 1}&page_size=${page_size || 100}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const AdminGetImages = createAsyncThunk(
  'imageSlice/GetImage',
  (payload, { rejectWithValue, getState }) => {
    return new Promise((resolve, reject) => {
      const { serial, page, page_size, camera, start_date, end_date } = payload;

      const serialParam = serial ? `serial=${serial}&` : '';

      axios({
        baseURL: '',
        url: `${STORAGE_BASE_URL}/device/captures?${serialParam}camera=${camera || ''}&start_date=${start_date || ''}&end_date=${end_date || ''}&page=${page || 1}&page_size=${page_size || 100}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const GetImagesByUserId = createAsyncThunk(
  'imageSlice/GetImage',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      const { id, data } = payload;
      const { serial, page, page_size, camera, start_date, end_date } = data;
      const serialParam = serial ? `serial=${serial}&` : '';
      axios({
        baseURL: '',
        url: `${STORAGE_BASE_URL}/device/captures?${serialParam}camera=${camera || ''}&start_date=${start_date || ''}&end_date=${end_date || ''}&page=${page || 1}&page_size=${page_size || 100}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const imageSlice = createSlice({
  name: 'imageSlice',
  initialState: {
    err: null,
    isLoading: false,
    currentPageId: 1,
    currentImageId: 1,
    totalPage: 0,
    listImage: [],

  },
  reducers: {
    setPageId: (state, action) => {
      state.currentPageId = action.payload;
    },
    setImageId: (state, action) => {
      state.currentImageId = action.payload;
    },
    resetListImg: (state, action) => {
      state.listImage = action.payload;
    },

  },
  extraReducers: {
    [GetImagesByUserId.pending]: (state, action) => {
      state.isLoading = true;
      state.err = null;
      state.listImage = [];
      state.totalPage = 0;
    },
    [GetImagesByUserId.fulfilled]: (state, action) => {
      state.isLoading = false;
      let images = action.payload.data || action.payload.captures || action.payload.payload?.images || [];
      images?.map(
        image =>
          (image.url = image.url?.startsWith('http') ? image.url : `https://img.vgps.vn/${image.url}`)
      );

      state.listImage = images;
      let totalImage = action.payload.total || action.payload.payload?.total || 0;
      state.totalPage =
        totalImage % PAGE_SIZE_IMAGE === 0
          ? totalImage / PAGE_SIZE_IMAGE
          : Math.ceil(totalImage / PAGE_SIZE_IMAGE);
    },
    [GetImagesByUserId.rejected]: (state, action) => {
      state.isLoading = false;
      state.err = 'Có lỗi xảy ra , không tải được ảnh ';
      state.listImage = [];
      state.totalPage = 0;
    },
    [GetImages.pending]: (state, action) => {
      state.isLoading = true;
      state.err = null;
      state.listImage = [];
      state.totalPage = 0;
    },
    [GetImages.fulfilled]: (state, action) => {
      state.isLoading = false;
      let images = action.payload.data || action.payload.captures || action.payload.payload?.images || [];
      images?.map(
        image =>
          (image.url = image.url?.startsWith('http') ? image.url : `https://img.vgps.vn/${image.url}`)
      );

      state.listImage = images;
      let totalImage = action.payload.total || action.payload.payload?.total || 0;
      state.totalPage =
        totalImage % PAGE_SIZE_IMAGE === 0
          ? totalImage / PAGE_SIZE_IMAGE
          : Math.ceil(totalImage / PAGE_SIZE_IMAGE);
    },
    [GetImages.rejected]: (state, action) => {
      state.isLoading = false;
      state.err = 'Có lỗi xảy ra , không tải được ảnh ';
      state.listImage = [];
      state.totalPage = 0;
    },
    [AdminGetImages.pending]: (state, action) => {
      state.isLoading = true;
      state.err = null;
      state.listImage = [];
      state.totalPage = 0;
    },
    [AdminGetImages.fulfilled]: (state, action) => {
      state.isLoading = false;
      let images = action.payload.data || action.payload.captures || action.payload.payload?.images || [];
      images?.map(
        image =>
          (image.url = image.url?.startsWith('http') ? image.url : `https://img.vgps.vn/${image.url}`)
      );

      state.listImage = images;
      let totalImage = action.payload.total || action.payload.payload?.total || 0;
      state.totalPage =
        totalImage % PAGE_SIZE_IMAGE === 0
          ? totalImage / PAGE_SIZE_IMAGE
          : Math.ceil(totalImage / PAGE_SIZE_IMAGE);
    },
    [AdminGetImages.rejected]: (state, action) => {
      state.isLoading = false;
      state.err = 'Có lỗi xảy ra , không tải được ảnh ';
      state.listImage = [];
      state.totalPage = 0;
    }
  }
});
export const { setImageId, setPageId, resetListImg } = imageSlice.actions;

export default imageSlice.reducer;
